import { render, staticRenderFns } from "./ManageContainer.vue?vue&type=template&id=06b42bcc"
import script from "./ManageContainer.vue?vue&type=script&lang=ts"
export * from "./ManageContainer.vue?vue&type=script&lang=ts"
import style0 from "./ManageContainer.vue?vue&type=style&index=0&id=06b42bcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports